import { render, staticRenderFns } from "./WelcomeLetter.vue?vue&type=template&id=f9ac2e98&"
import script from "./WelcomeLetter.vue?vue&type=script&lang=js&"
export * from "./WelcomeLetter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports